













import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
@Component({
  components: {}
})
export default class AuthoritySet extends AbpBase {
  baseData = [
    {
      expand: true,
      title: '后台权限',
      children: [
        {
          title: '常规商品',
          expand: true
        },
        {
          title: '兑换商品',
          expand: true
        },
        {
          title: '护理项目',
          expand: true
        },
        {
          title: '会员',
          expand: true
        },
        {
          title: '门店订单',
          expand: true
        },
        {
          title: '培训管理',
          expand: true
        },
        {
          title: '权限',
          expand: true
        },
        {
          title: '设置',
          expand: true
        },
        {
          title: '首页',
          expand: true
        },
        {
          title: '统计',
          expand: true
        },
        {
          title: '资讯文章',
          expand: true
        },
        {
          title: '组织管理',
          expand: true
        }
      ]
    }
  ]
  submit() {
    console.log('提交')
  }
}
